<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [title]="loaded ? headerText + (' Pro' | translate) : ''"
      [class]="extraClass"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper class="right-side-scroll-enabled">
      @if (loaded) {
        <tidy-card>
          <tidy-row>
            <ion-row>
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="job?.template_data?.job?.service_type_details?.service_category?.icon_url"
                  style="width:30px;" />
              </tidy-row>
              <ion-col>
                <tidy-row>
                  <tidy-text
                    [header]="(job?.template_data?.job?.service_type_details?.name || job?.template_data?.booking?.bookable_service?.name) | titlecase" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="(job?.template_data?.job?.start_datetime_local | parseDateTime: 'ddd') + ' ' + (job?.template_data?.job?.start_datetime_local | parseDateTime: 'MMM D') + (' at ' | translate) + (job?.template_data?.job?.start_datetime_local | parseDateTime: 'h:mma')" />
                </tidy-row>
              </ion-col>
            </ion-row>
          </tidy-row>
          <tidy-row class="extra-bottom-padding">
            <tidy-divider />
          </tidy-row>
          <tidy-row [ngClass]="form?.value?.existingOrNew === 'newPro' ? 'extra-bottom-padding' : ''">
            <tidy-radio-button
              [label]="'What do you want to do?'"
              formControlName="existingOrNew"
              [form]="form.controls.existingOrNew"
              (optionChange)="selectExistingOrNew($event)"
              [items]="existingOrNewItems" />
          </tidy-row>
          @if (selection === 'existingPro' && !privateProItems?.length) {
            <tidy-row>
              <tidy-row class="extra-top-padding extra-bottom-padding">
                <tidy-divider />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [body]="'You haven\'t added any private pros. Add pros to book jobs with them, collect payment and more.'" />
              </tidy-row>
            </tidy-row>
          }
          @if (form?.value?.existingOrNew === 'existingPro' && privateProItems?.length) {
            <tidy-row class="extra-top-padding">
              <tidy-radio-button
                [label]="'Select the pro:'"
                formControlName="privatePro"
                [form]="form.controls.privatePro"
                [items]="privateProItems"
                (optionChange)="selectPro($event)" />
            </tidy-row>
          }
          @if (form?.value?.existingOrNew === 'newPro') {
            <tidy-row class="field-top-padding field-bottom-padding">
              <tidy-input
                formControlName="name"
                [label]="'Their Name*'"
                [form]="form.controls.name"
                [submitted]="submitted"
                [errorMessage]="'Please enter a name.'"
                [icon]="'assets/svg/person.svg'" />
            </tidy-row>
            <tidy-row class="field-bottom-padding">
              <tidy-input
                formControlName="email"
                [label]="'Their Email*'"
                [form]="form.controls.email"
                type="email"
                [submitted]="submitted"
                [errorMessage]="'Please enter a valid email.'"
                [icon]="'assets/svg/mail.svg'" />
            </tidy-row>
            <tidy-row>
              <tidy-input-international-phone
                formControlName="phone"
                [label]="'Their Phone'"
                [form]="form.controls.phone"
                [inputMode]="'numeric'"
                [submitted]="submitted"
                [errorMessage]="'Please enter a valid phone.'"
                [icon]="'assets/svg/phone-portrait.svg'"
                [initialMask]="{ mask: '[00000000000000000000000]' }"
                (countryCodeChange)="onCountryCodeChange($event)" />
            </tidy-row>
          }
        </tidy-card>
        <tidy-button
          [text]="submitButtonText"
          [action]="boundConfirm"
          class="primary" />
        @if (errorMessage) {
          <tidy-error-message
            [text]="errorMessage" />
        }
      }
    </tidy-wrapper>
  </form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content>
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}

